import {
  Box,
  Button,
  CircularProgress,
  MenuItem,
  Select,
  Typography,
  Modal,
  useTheme,
  FormHelperText,
  useMediaQuery,
} from '@mui/material';
import { useEffect, useState, useRef } from 'react';
import { useForm, Controller, useFieldArray } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { useTranslation } from 'react-i18next';
import { useGetTemplates } from '../../hooks/useGetTemplates';
import { ControlledTextField } from '@frontend/features/common/components/ControlledTextField';
import { useSendTemplate } from '../../hooks/useSendTemplate';
import { useSendTemplateWithFile } from '../../hooks/useSendTemplateWithFile';
import { useWhatsappClient } from '../WhatsappClientContext';
import { LoadingButton } from '@mui/lab';
import { AttachFile } from '@mui/icons-material';

// Fixme: pasar toda esta validacion el backend
const MEVUELO_ALLOWED_TEMPLATE_IDS = [
  'd7039e2d-3869-41de-886b-4202580ca866',

  // SERVICENTER Y COLOMBIA

  '0a1dab00-ad57-4890-a8a6-ad678d103c80',
  '1b11fecf-0c2e-4d87-aafd-880b2f241a32',
  'e1cece2e-a989-4dc4-9da4-2a4d2c6a33a0',
  '1ad814ea-6d3a-4520-8f54-bc1292b2ce72',
  '2cb2306e-ec5b-4385-a710-c93ec199a8db',
  'c235a4c6-0189-42ce-9b51-31b0a2483f40',
  'bab94ef1-357e-4be7-8c91-4648021b8b08',
  '043c06ef-b9c2-45b3-b706-55ce95d73493',
  '3e436428-bd0a-45a5-a608-59c87bcfadc7',
  '160cef72-dc95-40d3-b11a-827e12076da6',
  '4a040d12-f40b-4a2b-bb9e-2f141d451710',
  '569ca9de-913a-49bb-b8db-97f94013b135',
  '27ad505e-31ca-49a8-aaa7-79ed9ec11ce8',
  '03a93b88-34d2-46ae-8130-27c2d7e1e61d',
  '8ca28c45-ee6e-4d36-ba31-7251949a61af',
  '173c6921-9b8d-49a9-a41d-be5fdd95038a',
  '6721df9e-b698-4592-8636-aa52e20d7fee',
  'bc81a07c-dadc-475e-ad67-a0b64a8c5e59',
  'ca1c631b-ec18-47fa-80a1-97c8777a57e8',
  '2e239043-8855-42a6-88b4-adace803473f',
  'f9462e99-ee2d-4e20-99f4-07c12a4fff94',
  'a34af3c0-e2b0-459b-a5c6-36909fbc665a',
  'd988cb5e-6299-4ac9-804a-e9d979d898cf',
  '8d613a97-2b3d-4ad5-b742-47a40acfe94b',
  'ca2c0a2f-bdd2-487d-be1b-1edc1ccdb0bc',
  '789dd268-da5d-4eca-ae76-d4225f910475',
  '47c29244-d42f-4231-8a1c-e2efd9bcc64e',
  '01969fb4-155c-4112-9c16-1c0e0d53b54d',
  'b8e9d798-d482-44b7-a2c7-b8d11059dfc8',

  // Tienda Naranja
  '17d3a2e7-e9a6-4703-82ad-fe5d03a8e04c',
  '1256cd8d-0697-4994-a97f-b08e574437f2',
  '0479f5a8-85c5-41c6-bb61-b66a08a33b03',
  '448874e6-0b75-41b4-9af7-43130cfe3385',
  'ffe39089-5de3-40c8-b95c-b1918d3e32fa',
  '58cc40cf-8cdd-467c-b09c-ea105ed55517',
  'ada374b1-5374-4998-8f0a-0dc5a404fc6e',
  '697a9c4a-a696-4309-9b5d-eaf0aa2066af',

  // Mevuelo paraguay
  '1d1d0c68-8bb3-4d75-b2b6-e89e6e943493',
  'f9b8b02b-44e9-4c10-ab94-46ccdda7294a',
  'e274e45f-ea3a-4bb4-a513-5fd710fa8309',
  'db0bc916-9de1-4330-8ebe-1e5c0e57e864',
  'e214cf1a-5ff3-4f11-8a67-1b25d35e9a89',
  'ec71be21-8b3d-4bd8-ae15-c7247703dcb9',
  '7de5fb13-0a66-4a90-8092-d8c6c7ef8669',
  'ccb8d077-b63d-4af2-a51d-546e72fe47ae',

  // Mevuelo uruguay
  '25c855a6-1b82-4e24-8a9e-fb14d225ee29',
  '6d1bba51-63f2-408f-a05e-d72dbbe69a47',
  '97a0055d-b4a7-4fd1-9e7f-4bc4735b4628',
  '68ff2b3d-98a7-41f7-b56d-32266ab2fb2b',
  'ae2e81b4-0441-44aa-9911-654f34fc7f5d',
  '3bb72af4-da46-49f5-baa0-8a8d116a19ae',
  'cfc884da-3c4e-4ac5-8d88-97dea1821028',

  // Mevuelo bolivia
  '68251a95-abe0-4608-95c4-3011f5d879bb', // feliz_viaje_v2
  '201f31ee-5e54-4af5-a34d-4710ff3075e0', // presentacion
  'f2b246b9-73c3-41c2-a2ff-9a19c2f3592f', // msj de saldo pendiente
  'b070db65-abbc-44c4-9b63-fe2d0c931717', // cotizacion 2
  '9749c955-517f-48b3-826f-190216cd8956', // seguimiento
  '62b31a91-329d-454d-bcd3-9e29380bb2f2', // link de coti
  '111536d4-54e6-40e8-aec9-1d6017ad0f87', // presentacion 2  
];

export function replacePlaceholders(template: string, values: string[]) {
  return template.replace(/{{(\d+)}}/g, (_, index) => {
    const i = parseInt(index, 10) - 1;
    return values[i] ?? '';
  });
}

const isMevueloDomain = () => {
  return Boolean(window.location.hostname.includes('mevuelo.com'));
};

const formSchema = z.object({
  templateId: z.string().nonempty('whatsapp.templateMessenger.selectTemplate'),
  placeholders: z.array(z.object({ value: z.string().nonempty('Campo requerido') })),
  file: z.any().optional(),
});

type FormValues = z.infer<typeof formSchema>;

export const TemplateMessenger = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
  const { t } = useTranslation();
  const { clientData } = useWhatsappClient();
  const sendTemplate = useSendTemplate(clientData?.agencyId);
  const sendTemplateWithFile = useSendTemplateWithFile(clientData?.agencyId);
  const { data, isLoading } = useGetTemplates(clientData?.agencyId);
  const { palette, breakpoints } = useTheme();
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [fileError, setFileError] = useState<string | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const {
    control,
    watch,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<FormValues>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      templateId: '',
      placeholders: [],
      file: undefined,
    },
    mode: 'onChange',
  });

  const templateId = watch('templateId');
  const placeholdersValues = watch('placeholders');
  
  const availableTemplates = !isMevueloDomain() 
    ? data?.templates
    : data?.templates.filter(t => MEVUELO_ALLOWED_TEMPLATE_IDS.includes(t.id));
  
  const selectedTemplate = availableTemplates?.find((t) => t.id === templateId);
  
  // Determinar si la plantilla requiere un archivo (tipo documento o imagen)
  const templateTypeLC = selectedTemplate?.templateType?.toLowerCase() || '';
  const isDocumentTemplate = templateTypeLC === 'document';
  const isImageTemplate = templateTypeLC === 'image';
  const requiresFile = isDocumentTemplate || isImageTemplate;

  const { fields, replace } = useFieldArray({
    control,
    name: 'placeholders',
  });

  useEffect(() => {
    if (!open) {
      reset({
        templateId: '',
        placeholders: [],
        file: undefined,
      });
      setSelectedFile(null);
      setFileError(null);
    }
  }, [open, reset]);

  useEffect(() => {
    if (selectedTemplate) {
      const placeholderMatches = selectedTemplate.data.match(/{{\d+}}/g) || [];
      
      const newPlaceholders = placeholderMatches.map(() => ({ value: '' }));
      
      if (fields.length !== newPlaceholders.length) {
        replace(newPlaceholders);
      }
      
      // Reset file when template changes
      setSelectedFile(null);
      setFileError(null);
    } else if (fields.length > 0) {
      replace([]);
    }
  }, [selectedTemplate, replace, fields.length]);

  const handleClose = () => {
    reset({
      templateId: '',
      placeholders: [],
      file: undefined,
    });
    setSelectedFile(null);
    setFileError(null);
    onClose();
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      setSelectedFile(file);
      setFileError(null);
    }
  };

  const onSubmit = async (data: FormValues) => {
    if (!selectedTemplate) return;

    const { templateId, placeholders } = data;
    const placeholderValues = placeholders.map((p) => p.value);
    const finalText = replacePlaceholders(selectedTemplate.data, placeholderValues);

    if (!clientData?.whatsappNumber) return;
    
    // Check if file is required but not provided
    if (requiresFile && !selectedFile) {
      setFileError(t('whatsapp.templateMessenger.fileRequired'));
      return;
    }

    const onSuccess = () => {
      reset({
        templateId: '',
        placeholders: [],
        file: undefined,
      });
      setSelectedFile(null);
      setFileError(null);
      onClose();
    };

    if (requiresFile && selectedFile) {
      // Use sendTemplateWithFile for document or image templates
      sendTemplateWithFile.mutate(
        {
          file: selectedFile,
          clientId: clientData.id,
          templateName: selectedTemplate.elementName,
          languageCode: selectedTemplate.languageCode || 'es',
          bodyParameters: placeholderValues.length > 0 
            ? placeholderValues.map(value => ({ type: 'text', text: value })) 
            : undefined,
        },
        { onSuccess }
      );
    } else {
      // Use regular sendTemplate for text templates
      sendTemplate.mutate(
        {
          destination: clientData.whatsappNumber,
          templateId: templateId,
          templateParams: placeholderValues || [],
          messageText: finalText,
        },
        { onSuccess }
      );
    }
  };
  
  const isMobile = useMediaQuery(breakpoints.down('md'));

  if (isLoading && !isMobile) return <CircularProgress />;

  const canSubmit = () => {
    if (!templateId) return false;
    
    if (requiresFile && !selectedFile) return false;
    
    if (fields.length > 0) {
      return placeholdersValues?.every(p => p?.value.trim() !== '');
    }
    
    return true;
  };

  const previewText = selectedTemplate 
    ? replacePlaceholders(
        selectedTemplate.data,
        (placeholdersValues || []).map((p) => p?.value || '')
      )
    : '';

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          minWidth: 300,
          maxWidth: 800,
          maxHeight: '90vh',
          overflow: 'auto',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
        }}
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box display="flex" flexDirection="column" gap={3}>
            <Typography variant="h6" align="center" gutterBottom>
              {t('whatsapp.templateMessenger.title')}
            </Typography>
            
            <Controller
              name="templateId"
              control={control}
              render={({ field }) => (
                <Select 
                  {...field} 
                  displayEmpty 
                  fullWidth
                  error={!!errors.templateId}
                >
                  <MenuItem value="" disabled>
                    {t('whatsapp.templateMessenger.selectTemplate')}
                  </MenuItem>
                  {availableTemplates?.map((tpl) => (
                    <MenuItem key={tpl.id} value={tpl.id}>
                      {tpl.elementName} {tpl.templateType ? `(${tpl.templateType.toLowerCase()})` : ''}
                    </MenuItem>
                  ))}
                </Select>
              )}
            />
            
            {selectedTemplate && (
              <>
                <Box>
                  <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                    {t('whatsapp.templateMessenger.preview')}
                  </Typography>
                  <Typography 
                    variant="body1" 
                    sx={{ 
                      p: 2, 
                      bgcolor: palette.paper.dark, 
                      borderRadius: 1,
                      whiteSpace: 'pre-wrap'
                    }}
                  >
                    {previewText}
                  </Typography>
                </Box>

                {requiresFile && (
                  <Box>
                    <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                      {t('whatsapp.templateMessenger.uploadFile')}
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <Button
                        variant="outlined"
                        onClick={() => fileInputRef.current?.click()}
                        startIcon={<AttachFile />}
                      >
                        {t('common.selectFile')}
                      </Button>
                      <input
                        ref={fileInputRef}
                        type="file"
                        onChange={handleFileChange}
                        accept={isImageTemplate ? 'image/*' : '*/*'}
                        style={{ display: 'none' }}
                      />
                      {selectedFile ? (
                        <Typography variant="body2" sx={{ ml: 1, flexGrow: 1, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                          {selectedFile.name}
                        </Typography>
                      ) : (
                        <Typography variant="body2" color="text.secondary">
                          {t('whatsapp.templateMessenger.noFileSelected')}
                        </Typography>
                      )}
                    </Box>
                    {fileError && (
                      <FormHelperText error>{fileError}</FormHelperText>
                    )}
                  </Box>
                )}

                {fields.length > 0 && (
                  <Box>
                    <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                      {t('whatsapp.templateMessenger.completeFields')}
                    </Typography>
                    <Box display="flex" flexDirection="column" gap={2}>
                      {fields.map((field, idx) => (
                        <ControlledTextField
                          key={field.id}
                          control={control}
                          name={`placeholders.${idx}.value`}
                          placeholder={t('whatsapp.templateMessenger.placeholder', { number: idx + 1 })}
                          required
                          errorMessage={errors.placeholders?.[idx]?.value?.message}
                          fullWidth
                        />
                      ))}
                    </Box>
                  </Box>
                )}
              </>
            )}

            <Box display="flex" justifyContent="space-between" mt={2}>
              <Button onClick={handleClose} variant="outlined">
                {t('common.cancel')}
              </Button>
              <LoadingButton 
                variant="contained" 
                color="primary" 
                type="submit"
                disabled={!canSubmit()}
                loading={sendTemplate.isLoading || sendTemplateWithFile.isLoading}
              >
                {t('whatsapp.templateMessenger.sendMessage')}
              </LoadingButton>
            </Box>
          </Box>
        </form>
      </Box>
    </Modal>
  );
};
